export const SIZES = {
  sm: 'sm',
  base: 'base',
  lg: 'lg',
}
